import { INTERACTION_TYPE } from "./ai.schema";

export const InteractionTypeMap: Record<INTERACTION_TYPE, string> = {
  [INTERACTION_TYPE.ANALYSIS]: "Deal Analysis",
  [INTERACTION_TYPE.DEAL_CHAT]: "Deal Chat",
  [INTERACTION_TYPE.REGULAR_CHAT]: "Regular Chat",
  [INTERACTION_TYPE.TOOL_CHAT]: "UW Tools"
}

export interface ChatHistory {
  skill: string;
}